import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DialogReservation from '../DialogValidation/DialogValidation'
import UnlockWithPaiement from '../DialogValidation/UnlockWithPaiement'
import { useStyles } from './TabReservationStyle'
import { useSnackbar } from 'notistack'

//Redux
import allActions from '../../../redux/actions/user'


//Material UI
import AddIcon from '@material-ui/icons/Add'
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import Tooltip from '@material-ui/core/Tooltip'

function Creneau({ infoCreneau, date, centre, actionReservation }) {
  const classes = useStyles()
  const state = useSelector(state => state)
  const [status, setstatus] = useState({ disponible: true, status: '', motif: '' })
  const [className, setclassName] = useState('')

  useEffect(() => { setColorBackground() }, [status])

  useEffect(() => {
    checkDisponibility()
    setColorBackground()
  }, [date, centre, infoCreneau])


  //Retourne l'heure actuelle sous formme HH
  function getHeure() { return new Date().getHours() }

  function setColorBackground() {
    let color = ''

    switch (status.status) {
    case 'LIBRE':
      color = classes.valid
      break

    case 'MODIFIABLE':
      color = classes.reserved
      break

    case 'ATTENTE':
      color = classes.waiting
      break

    case 'INDISPONIBLE':
      color = classes.invalid
      break

    case 'INDISPONIBLE_RESERVE':
      color = classes.reserved
      break

    default:
      break
    }
    setclassName(color)
  }

  function creneauHorsDelais(heureDebut) {
    heureDebut = heureDebut.split(':')[0]

    const d1 = date.toISOString().split('T')[0]
    const d2 = new Date().toISOString().split('T')[0]

    if (getHeure() >= heureDebut && d1 === d2) return true
  }

  function checkDisponibility() {
    let dispo = { disponible: true, status: 'LIBRE', motif: 'Disponible', label: 'Libre' }

    if (infoCreneau.inva_libelle) {
      dispo = {
        disponible: false,
        status: 'INDISPONIBLE',
        motif: infoCreneau.inva_libelle,
        label: 'Indisponible'
      }
    }
    //UUID correspondant à PASSEPORT pour le moment mais utilisé pour bloquer la reservation (accès concurrentiel)
    else if (infoCreneau.id_2 === '93BBD2BB-527B-4554-B41C-FFB4368C4161' && infoCreneau.id_1 === state.user.id) {
      dispo = {
        disponible: false,
        status: 'ATTENTE',
        motif: 'Aucun paiement validé',
        label: 'En attente de paiement'
      }
    }
    else if ((infoCreneau.id_1 === state.user.id || infoCreneau.id_2 === state.user.id) && creneauHorsDelais(infoCreneau.rescre_heuredebut)) {
      dispo = {
        disponible: false,
        status: 'INDISPONIBLE_RESERVE',
        motif: 'Créneau dépassé',
        label: 'Réservé'
      }
    }
    else if (infoCreneau.id_1 === state.user.id || infoCreneau.id_2 === state.user.id) {
      dispo = {
        disponible: false,
        status: 'MODIFIABLE',
        motif: 'Créneau réservé',
        label: infoCreneau.lici_id_1_name + ' / ' + infoCreneau.lici_id_2_name
      }
    }

    else if (infoCreneau.id_1 || infoCreneau.id_2) {
      dispo = {
        disponible: false,
        status: 'INDISPONIBLE',
        motif: 'Créneau déja reservé',
        label: 'Indisponible'
      }
    }
    else if (creneauHorsDelais(infoCreneau.rescre_heuredebut)) {
      dispo = {
        disponible: false,
        status: 'INDISPONIBLE',
        motif: 'Créneau dépassée',
        label: 'Indisponible'
      }
    }

    setstatus(dispo)
  }

  return (
    <div className={classes.titem} style={{ padding: 4 }}>
      <div
        className={classes.creneau + ' ' + className}
        onClick={() => actionReservation(status.status, infoCreneau, centre, date)}
      >
        <p>{status.label}</p>
        {status.status === 'LIBRE' && <AddIcon />}
        {status.status === 'INDISPONIBLE' && <NotInterestedIcon />}
      </div>
    </div>
  )
}

export default function TabReservation({ centre, date, setmove, move }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [load, setload] = useState(false)
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const [listTerrain, setlistTerrain] = useState([])
  const [dataActionReservation, setDataActionReservation] = useState({ centre: '1', court: '1', date: '1', creneau: '', TERID: '', ownerId: '', guestId2: '' })
  const [dialogOpen, setdialogOpen] = useState(false)
  const [oldReservation, setoldReservation] = useState({})
  const horaires = ['8h-9h', '9h-10h', '10h-11h', '11h-12h', '12h-13h', '13h-14h', '14h-15h', '15h-16h', '16h-17h', '17h-18h', '18h-19h', '19h-20h', '20h-21h', '21h-22h']

  function reload() { setload(!load) }

  useEffect(() => {
    async function fetchData() {
      dispatch(allActions.setLoading(true))

      //Récupères la liste des centres, et pour le centre la liste de chaque terrain. Centre par défaut le 41 
      const res = await allActions.fetchGetAPI(`api/reservation/centres/${centre}`, false, token)
      const terrains = await Promise.all(res.json.data.map(
        async (terrain) => {
          const url = `api/reservation/centres/reservations/${terrain.TER_ID}/${date.toISOString().split('T')[0]}`
          const result = await allActions.fetchGetAPI(url, false, token)
          return result.json.data.recordset
        }))
      setlistTerrain(terrains)
      dispatch(allActions.setLoading(false))

    }

    fetchData()
  }, [centre, date, load])

  function actionReservation(status, creneauInfo, centre, date) {
    setDataActionReservation({
      centreId: centre,
      date: date,
      court: creneauInfo.ter_designation,
      status: status,
      creneauInfo: creneauInfo,
      ownerId: creneauInfo.id_1,
      guestId2: creneauInfo.id_2
    })
    setdialogOpen(true)
  }

  async function moveCreneau(newCreneauInfo) {
    if (newCreneauInfo.status === 'INDISPONIBLE') {
      enqueueSnackbar(`Créneau indisponible`, { variant: 'error' })
    }
    else {
      enqueueSnackbar(`Chargement...`, { variant: 'info' })

      let body3 = {
        userId: oldReservation.ownerId,
        guestId: oldReservation.guestId2,
        cntId: centre,
      }

      const res = await fetch(process.env.REACT_APP_API_PATH + `api/reservation/centres/reservations/${newCreneauInfo.creneauInfo.rescre_id}/${newCreneauInfo.date.toISOString().split('T')[0]}/${oldReservation.res_id}`, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify(body3)
      })

      const json = await res.json()
      enqueueSnackbar(`${json.message}`, { variant: json.variant })
      setmove(false)
      setdialogOpen(false)
      reload()
    }

  }

  function ShowActionReservation() {

    //Si c'est un déplacement de créneau
    if (move) moveCreneau(dataActionReservation)
    else {
      switch (dataActionReservation.status) {
      case 'LIBRE':
        return <DialogReservation
          open={dialogOpen}
          status={dataActionReservation.status}
          titre="Création d'une réservation"
          centreId={dataActionReservation.centreId}
          court={dataActionReservation.court}
          res_id={dataActionReservation.creneauInfo.res_id}
          date={dataActionReservation.date}
          rescre_id={dataActionReservation.creneauInfo.rescre_id}
          creneau={dataActionReservation.creneauInfo.rescre_heuredebut}
          ownerId={dataActionReservation.ownerId}
          guestId2={dataActionReservation.guestId2}
          reload={reload}
          close={setdialogOpen}
          setmove={setmove}
          setoldReservation={setoldReservation}
        />
        break
      case 'ATTENTE':
        return <UnlockWithPaiement
          open={dialogOpen}
          status={dataActionReservation.status}
          titre="Créneau bloqué"
          centreId={dataActionReservation.centreId}
          court={dataActionReservation.court}
          res_id={dataActionReservation.creneauInfo.res_id}
          date={dataActionReservation.date}
          rescre_id={dataActionReservation.creneauInfo.rescre_id}
          creneau={dataActionReservation.creneauInfo.rescre_heuredebut}
          ownerId={dataActionReservation.ownerId}
          guestId2={dataActionReservation.guestId2}
          reload={reload}
          close={setdialogOpen}
        />
        break

      case 'MODIFIABLE':
        return <DialogReservation
          open={dialogOpen}
          status={dataActionReservation.status}
          titre="Modification d'une réservation"
          centreId={dataActionReservation.centreId}
          court={dataActionReservation.court}
          res_id={dataActionReservation.creneauInfo.res_id}
          date={dataActionReservation.date}
          rescre_id={dataActionReservation.creneauInfo.rescre_id}
          creneau={dataActionReservation.creneauInfo.rescre_heuredebut}
          ownerId={dataActionReservation.ownerId}
          guestId2={dataActionReservation.guestId2}
          reload={reload}
          close={setdialogOpen}
          setmove={setmove}
          setoldReservation={setoldReservation}
        />
        break

      case 'INDISPONIBLE':

        break

      default:
        break


      }
    }
  }

  function displayNumTerrain(numTerrain) {
    if(numTerrain > 9) {
      return numTerrain
    } else if(numTerrain.startsWith('0')){
      return numTerrain.split('0')[1]
    }
    else {
      return numTerrain
    }
  }

  return (
    <div className={classes.root}>

      {dialogOpen && ShowActionReservation()}

      <div className={classes.table} >
        <div className={classes.thead}>
          <div className={classes.trowhead}>
            <div className={classes.titem}>Horaires</div>
            {listTerrain.map((terrain, i) => (
              <Tooltip key={i} placement="top" arrow={true} title={`Terrain N°${displayNumTerrain(terrain[0].ter_designation ?? 0)} (${terrain[0].surf_libelle})`}>
                <div className={classes.titemhead}>
                  <div><span className={classes.libelleTerrain}>Terrain </span> N°{displayNumTerrain(terrain[0].ter_designation ?? 0)}</div>
                  <div className={classes.typeTerrain}> ({terrain[0].surf_libelle})</div>
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
        <div className={classes.tbody}>
          {/* {horaires.map((h, i) => (
            <div className={classes.trow} key={i}>
              <div className={classes.titem}>{h}</div>
              {listTerrain?.map((terrain, j) => {
                if(terrain.findIndex((t => h === t.horaire) !== -1)
                  return <Creneau 
                          infoCreneau={terrain[i]} 
                          date={date}
                          centre={centre}
                          actionReservation={actionReservation}
                          key={j}
                        />
                
              })}
                
                
                
                // .horaire ? 
                //    :
                //   <div className={classes.titem} style={{ padding: 4 }} key={j} >
                //     <div className={classes.creneau + ' ' + classes.invalid}>
                //       <p>Indisponible</p>
                //       <NotInterestedIcon />
                //     </div>
                //   </div>
              // ))}
            </div>
          ))} */}

          {horaires.map((h, i) => (
            <div className={classes.trow} key={i}>
              <div className={classes.titem}>{h}</div>
              {listTerrain?.map((terrain, j) => {
                const index =  terrain.findIndex(t => h === t.horaire)
                if (index !== -1) {
                  return <Creneau
                    infoCreneau={terrain[index]}
                    date={date}
                    centre={centre}
                    actionReservation={actionReservation}
                    key={j}
                  />
                } else {
                  return <div className={classes.titem} style={{ padding: 4 }} key={j} >
                    <div className={classes.creneau + ' ' + classes.invalid}>
                      <p>Indisponible</p>
                      <NotInterestedIcon />
                    </div>
                  </div>
                }

              })}
            </div>
          ))}
        </div>
      </div>

    </div>
  )

}


